@if (warning) {
  <div>
    @if (warningConfirmState === vehicleWarningConfirmState.DisplayConfirmDialog) {
      <div class="confirmation-container">
        <div class="confirmation-card add-shadow">
          <div class="card-header">
            <app-warning-icon [messageType]="warning.messageType"></app-warning-icon>
            {{'Warning' | translate}} {{ warning.messageType | formatWarningMessageType:'shortHeader'}}
            <span>{{warning?.measuredAt | date:'HH:mm'}}</span>
          </div>
          <div class="card-body">
            <label for="comment-field">{{'Comment' | translate}}</label>
            <div class="textarea-container">
              <textarea id="comment-field" [(ngModel)]="commentField" rows="4"
              placeholder="{{reasonPlaceholder}}"></textarea>
            </div>
            <div class="button-container">
              <button type="button" aria-label="confirm" [disabled]="!commentField" (click)="confirm()"
                class="primary-button" [ngClass]="{'disabled': !commentField}">{{'Confirm' |
              translate}}</button>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
}
@if (warningConfirmState === vehicleWarningConfirmState.DisplayUndoMessage) {
  <app-feedback-text type="success">
    <div class="d-flex flex-1 flex-column">
      <div class="d-flex flex-1 justify-content-between">
        {{'Warning' | translate}} {{ warning.messageType | formatWarningMessageType:'shortHeader'}} {{'confirmed' |
        translate}}
        <a (click)="cancel()" class="undo-button">{{'Undo' | translate}} <i class="pr-2 fa fa-undo"></i></a>
      </div>
      <div class="pt-3">
        <mat-progress-bar color="accent" mode="determinate" [value]="progress"></mat-progress-bar>
      </div>
    </div>
  </app-feedback-text>
}